
// export const satIds = [48268]; //, 49070, 59625, 59625, 59626, 60452, 60453, 62900, 62901];
export const satIds = [40115, 48268, 49070, 59625, 59625, 59626, 60452, 60453, 62900, 62901, 63027, 64231];

export function getSatelliteName( id: number ): string {
    const nameMap: Record<number, string> = {
        40115: "WORLDVIEW-3",
        48268: "PNEO3",
        49070: "PNEO4",
        59625: "LEGION 1",
        59626: "LEGION 2",
        60452: "LEGION 3",
        60453: "LEGION 4",
        62900: "LEGION 5",
        62901: "LEGION 6",
        63027: "GLOBAL-31",
        64231: "GLOBAL-32",
    };
    return nameMap[id] || "Error!";
};

export const twoLineEls = [
    {
        id: "PNEO3",
        tle: [
            "1 48268U 21034A   26014.61678755  .00000001  00000-0  67310-5 0  9999",
            "2 48268  97.8941  91.5868 0001283  89.0313 271.1047 14.81670705254915"
        ],
    },
    {
        id: "PNEO4",
        tle: [
            "1 49070U 21073E   26014.65054007  .00000539  00000-0  75137-4 0  9997",
            "2 49070  97.8942  91.6160 0001388  91.4734 268.6638 14.81674974238634"
        ],
    },
    {
        id: "LEGION 1 (ORIGINAL)",
        tle: [
            "1 59625U 24081A   26014.52201248  .00002747  00000-0  14299-3 0  9997",
            "2 59625  97.5174  93.8821 0004935 175.7618 184.3658 15.16856133 94242"
        ]
    },
    {
        id: "LEGION 1",
        tle: [            
            "1 59625U 24081A   25235.90282259  .00003815  00000-0  19463-3 0  9999",
            "2 59625  97.5328 311.3615 0005002 133.0153 227.1500 15.17331047 72475"
        ],
    },
    {
        id: "LEGION 2",
        tle: [
            "1 59626U 24081B   26014.55472827  .00003106  00000-0  16114-3 0  9992",
            "2 59626  97.5176  94.0039 0007286 163.9587 196.1878 15.16873692 94250"
        ],
    },
    {
        id: "LEGION 3",
        tle: [
            "1 60452U 24146A   26014.50680750  .00002828  00000-0  15749-3 0  9997",
            "2 60452  45.0003 134.4211 0014493  15.0000 345.1306 15.16129838 78702"
        ],
    },
    {
        id: "LEGION 4",
        tle: [
            "1 60453U 24146B   26014.57150133  .00002666  00000-0  14898-3 0  9996",
            "2 60453  45.0362 225.9193 0007859 152.4631 207.6666 15.16238630 77565"
        ],
    },
    {
        id: "LEGION 5",
        tle: [
            "1 62900U 25025A   26014.44273793  .00002566  00000-0  14440-3 0  9998",
            "2 62900  45.0472  45.5698 0008301 319.6417  40.3845 15.16109832 51164"
        ],
    },
    {
        id: "LEGION 6",
        tle: [
            "1 62901U 25025B   26014.24383383  .00003533  00000-0  19326-3 0  9997",
            "2 62901  44.9958 315.8447 0015680 335.8117  24.2024 15.16131071 52275"
        ],
    }
];

// const fakeCalculatePasses = async() => {
//     console.log( "Beginning Fake For Loop" )
//     for( let i = 0; i < 10; i++ ) {
//         console.log( `Exec: ${i}` )
//         const msg: WorkerResponsePass = {
//             type: WorkerResponseType.PassFound, 
//             payload: {
//                 satelliteId:   i,
//                 date:          Instant.now().toEpochMilli(),
//                 earlyTime:     Instant.now().toEpochMilli(),
//                 apexTime:      Instant.now().toEpochMilli(),
//                 lastTime:      Instant.now().toEpochMilli(),
//                 minAlt:        0,
//                 meanAlt:       0,
//                 maxAlt:        0,
//                 minOffNadir:   0,
//                 meanOffNadir:  0,
//                 maxOffNadir:   0,
//             }
//         }            
//         await sendStatus( "Progress", i / 10 );
//     }
//     await sendStatus( "Progress", 1.0 );
// }